module.exports = __webpack_public_path__ + "static/media/instructions.441003f0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/information/beers/instructions.jpg
// module id = 582
// module chunks = 0